import * as React from 'react';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import Translate from '../../common/functions/translate';
import Dialog from '@material-ui/core/Dialog';
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import * as Modal from '../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import OfferService from '../../services/offerService';
import Spinner from '../../common/components/spinner/spinner';
import Snackbar from "../../common/components/snackbar/snackbar";
import { DropdownModel } from '../../models/dropdownModel';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { OfferStatus } from "../../common/enums";
import UserService from '../../services/userService';
import AuthService from '../../services/authService';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { OfferGridModel } from "../../models/offer/offerGridModel";
import { OfferTransferModel } from "../../models/offer/offerTransferModel";
import { UserDropdownModel } from '../../models';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@material-ui/core/TableContainer';

interface IProps {
    cancelClick: any;
    saveClick: any;
    isVisible: boolean;
    selectedOffers: Array<OfferGridModel>;
}

interface IState {
    validationMessage: string;
    isLoading: boolean;
    selectedOffers: Array<OfferGridModel>;
    usersDropdown: Array<DropdownModel>;
    selectedTrader: DropdownModel;
}

const theme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: 5,
                marginBottom: 0,
                width: '100%'
            },
            root: {
                width: '100%'
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: '0px'
            }
        },
        MuiDialog: {
            paper: {
                margin: 0,
                maxWidth: '50% !important'
            },
            paperFullWidth: {
                width: '1000px'
            }
        },
    },
    palette: {
        primary: blue
    }
})

class OfferTransferDialog extends React.Component<IProps, IState> {
    snackbar: any;
    authService = new AuthService();
    offerService = new OfferService();
    userService = new UserService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            validationMessage: '',
            isLoading: false,
            usersDropdown: new Array<DropdownModel>(0),
            selectedOffers: this.props.selectedOffers,
            selectedTrader: new DropdownModel()
        };
    }

    componentDidMount() {
        this.setState({
            isLoading: true
        });

        this.initUsersDropdown();
    }

    initUsersDropdown = () => {

        if (this.authService.checkIsTrader()) {
            this.setState({
                isLoading: false,
            });
            return;
        }

        let regionId, roleId = 4;
        if (this.authService.checkIsRegionalManager()) {
            regionId = this.authService.getUserRegionId();
            //roleId = 4;
        }

        this.userService.getUsersByRegionAndRole(regionId, roleId).then(
            (data: any) => {
                let usersDropdown = new Array<DropdownModel>(0);
                data.forEach(r => usersDropdown.push({ label: r.name, value: r.userId, additionalData: r.phone }));
                this.setState({
                    isLoading: false,
                    usersDropdown: usersDropdown
                });
            })
            .catch(error => {
                this.snackbar.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                });
            });
    }

    isValidTransferForm() {
        let message = '';

        let trader = { ...this.state.selectedTrader }

        if (!trader || (trader && !trader.value)) {
            message += Translate('Choose trader') + '<br />';
        }

        if (this.state.selectedOffers.length < 1) {
            message += Translate('Choose atleast one offer to transfer') + '<br />';
        }

        this.setState({
            validationMessage: message
        });

        return message === '';
    }

    handleSaveButton = (event) => {
        event.preventDefault();

        if (!this.isValidTransferForm()) return;

        let newOfferTransfer = new OfferTransferModel();
        newOfferTransfer.offers = this.state.selectedOffers;
        newOfferTransfer.trader = new UserDropdownModel();
        newOfferTransfer.trader.userId = this.state.selectedTrader.value;
        newOfferTransfer.trader.name = this.state.selectedTrader.label;
        newOfferTransfer.trader.phone = this.state.selectedTrader.additionalData ? this.state.selectedTrader.additionalData : "";

        this.props.saveClick(newOfferTransfer);
    };

    handleCancelButton = () => {
        this.props.cancelClick();
    }

    handleAutocompleteChange = (e, newValue) => {
        this.setState({ selectedTrader: newValue });
    }

    hanleRemoveOfferClick = (id) => {
        let offers = this.state.selectedOffers;
        let removeIndex = offers.map(item => item.id).indexOf(id);
        if (removeIndex || removeIndex === 0) {
            offers.splice(removeIndex, 1);
            this.setState({
                selectedOffers: offers
            });
        }
    }

    public render() {

        const { isLoading, selectedOffers, usersDropdown, selectedTrader } = this.state;

        let currentTrader: DropdownModel | null = null;
        if (selectedTrader && selectedTrader.value) {
            currentTrader = selectedTrader;
        }

        return (
            <>
                <MuiThemeProvider theme={theme}>
                    <Dialog
                        open={this.props.isVisible}
                        onClose={this.handleCancelButton}
                        fullWidth
                    >
                        <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{Translate('TransferOffers')}</Modal.DialogTitle>
                        <Modal.DialogContent>
                            {isLoading ? <Spinner /> : null}
                            <Snackbar ref={(el) => this.snackbar = el} />
                            {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
                            <div>
                                <TableContainer component={Paper} style={{ maxHeight: "400px" }}>
                                    <Table stickyHeader size="small" >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><strong>{Translate('Date')}</strong></TableCell>
                                                <TableCell><strong>{Translate('Status')}</strong></TableCell>
                                                <TableCell><strong>{Translate("Number")}</strong></TableCell>
                                                <TableCell><strong>{Translate("Trader")}</strong></TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {selectedOffers.map((s, i) => {
                                                return (
                                                    <TableRow key={i}>
                                                        <TableCell>
                                                            {HelperFunctions.fomatDatesStringWithLang(new Date(s.offerDate))}
                                                        </TableCell>
                                                        <TableCell>
                                                            {HelperFunctions.getEnumLabel(s.offerStatusId, OfferStatus, true)}
                                                        </TableCell>
                                                        <TableCell>
                                                            {s.offerNumber}
                                                        </TableCell>
                                                        <TableCell>
                                                            {s.traderName}
                                                        </TableCell>
                                                        <TableCell>
                                                            <div
                                                                key={s.id}
                                                                style={{ marginRight: ".5em", cursor: "pointer" }}
                                                                onClick={(e) => this.hanleRemoveOfferClick(s.id)}
                                                            >
                                                                <FontAwesomeIcon
                                                                    title={Translate('Remove')}
                                                                    icon={faTimesCircle}
                                                                    style={{ fontSize: 20, color: "#e91224" }}
                                                                ></FontAwesomeIcon>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <Paper style={{ margin: '20px 0px', display: 'flex', flexDirection: 'row', padding: 15 }}>
                                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                                        {!this.authService.checkIsTrader() ?
                                            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15, width: '350px' }}>
                                                <div style={{ width: '100%', marginRight: 10 }}>
                                                    <Autocomplete
                                                        options={usersDropdown}
                                                        getOptionLabel={option => option.label}
                                                        value={currentTrader}
                                                        onChange={(e, newValue) => this.handleAutocompleteChange(e, newValue)}
                                                        renderInput={params => (
                                                            <TextField
                                                                {...params}
                                                                label={Translate('Trader')}
                                                                placeholder={Translate('TraderName')}
                                                                fullWidth
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            : null
                                        }
                                    </div>
                                </Paper>

                            </div>
                        </Modal.DialogContent>
                        <Modal.DialogActions>
                            <div>
                                <Button onClick={this.handleCancelButton} variant="contained" style={{ marginRight: 10 }}>
                                    {Translate("Cancel")}
                                </Button>
                                <Button onClick={(e) => this.handleSaveButton(e)} color="primary" variant="contained">
                                    {Translate("Transfer")}
                                </Button>
                            </div>
                        </Modal.DialogActions>
                    </Dialog >
                </MuiThemeProvider >
            </>
        )
    }
}

export default OfferTransferDialog;